import { IBranchState } from './types';

const initialBranchState = (): IBranchState => ({
  loading: false,
});

export default initialBranchState;
